import { render, staticRenderFns } from "./CrmCallEvent.vue?vue&type=template&id=9650fa3a"
import script from "./CrmCallEvent.vue?vue&type=script&lang=ts"
export * from "./CrmCallEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9650fa3a')) {
      api.createRecord('9650fa3a', component.options)
    } else {
      api.reload('9650fa3a', component.options)
    }
    module.hot.accept("./CrmCallEvent.vue?vue&type=template&id=9650fa3a", function () {
      api.rerender('9650fa3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/events/CrmCallEvent.vue"
export default component.exports